"use client"

import { DashboardSectionTitle } from "@/components/dashboard-section-heading"
import { TermResponseTrendChart } from "@/components/evaluation-dashboard/closed-term-response-trend"
import { EvaluationAnalyticFocusTerm } from "@/components/evaluation-dashboard/evaluation-analytic-focus-term"
import { EVAL_DASHBOARD_SECTION_H2_CLASS } from "@/lib/evaluation-dashboard-a11y"
import { cn } from "@/lib/utils"
import type { EvaluationTerm } from "@/lib/mock/evaluation-dashboard"

interface OperationsLastClosedTermSectionProps {
  term: EvaluationTerm
  /** Full-width trend chart below the focus card (default on). */
  includeTrendChart?: boolean
  /** Paired layout: focus card only, no section title. */
  compact?: boolean
  /** Side by side with live term — equal column height. */
  layout?: "default" | "paired"
}

/** Last closed term — same card as the Analytics dashboard approach. */
export function OperationsLastClosedTermSection({
  term,
  includeTrendChart = true,
  compact = false,
  layout = "default",
}: OperationsLastClosedTermSectionProps) {
  const isPaired = layout === "paired"

  return (
    <section
      aria-labelledby={compact ? undefined : "eval-operations-last-closed-heading"}
      className={cn("flex flex-col gap-4", isPaired && "h-full")}
    >
      {!compact ? (
        <DashboardSectionTitle
          as="h2"
          id="eval-operations-last-closed-heading"
          className={EVAL_DASHBOARD_SECTION_H2_CLASS}
        >
          Last closed term
        </DashboardSectionTitle>
      ) : null}
      <EvaluationAnalyticFocusTerm
        term={term}
        compact={compact}
        paired={isPaired}
        className={isPaired ? "min-h-0 flex-1" : undefined}
      />
      {includeTrendChart ? <TermResponseTrendChart focusTerm={term} /> : null}
    </section>
  )
}
